module.exports = __webpack_public_path__ + "img/antes_despues_234.ad804db8.png";